import React, { Component } from 'react'
import './style.css';
import parse from 'html-react-parser';
import ERROR_MESSAGES from './ErrorMessages';

export class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caseNumber: '',
            caseNumberError: '',
            validationSuccess: false,
            isAPIError: false,
            isSubmittng: false,
            caseData: null
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.renderBalance = false;
    }
   

    handleSubmit(e) {
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
        e.preventDefault();
        this.validateInput();
        if (this.state.validationSuccess) {
            this.setState({ isSubmittng: true });
            var url = API_BASE_URL + '/api/ESPcase?caseNumber=' + this.state.caseNumber;
            fetch(url)
                .then(res => res.json())
                .then(data => {
                    this.redirectToBalance(data);
                })
                .catch((err) => {
                    console.log("Error while fetchig data from API: " + err.message);
                    this.setState({
                        isAPIError: true
                    });
                    this.setState({ isSubmittng: false });
                });
        }
    }

    validateInput() {
        let caseNumberError = "";

        if (!this.state.caseNumber) {
            caseNumberError = ERROR_MESSAGES.NO_CASE_NUMBER;
        }
        else {
            const pattern = /\s*(([AaCcFfUuRrSsNn](\d{2}-\d{4}-\d{4}|\d{10}))|([MmDd](\w{2}-\w{4}-\w{3}|\w{9})))\s*/;
            const result = pattern.test(this.state.caseNumber);
            if (result === false) {
                caseNumberError = ERROR_MESSAGES.INVALID_CASE_NUMBER;
            }
        }

        if (caseNumberError) {
            this.setState({ caseNumberError: caseNumberError, validationSuccess: false });
        }
        else {
            this.state.validationSuccess = true;
        }
    }

    redirectToBalance(data) {
        if (this.state.validationSuccess)
            this.props.history.push("/Balance",  data);
    }


    handleInputChange(event) {
        const target = event.target;
        var value = target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
    }

    render() {
        if (this.state.isAPIError) {
            return (
                <div className="col" tabIndex="0" role="error">
                    <label> {parse(ERROR_MESSAGES.API_ERROR)}</label>
                </div>
            );
        }
        else if (this.state.isSubmittng) {
            return (
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div>
                    <form>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="font-weight-bold" tabIndex="0">Reference Number:<br /><i>Uimhir Thagartha:</i> </label>
                            </div>
                            <div className="form-group col-md-8">
                                <input type="text" name="caseNumber" size="11" value={this.state.caseNumber} aria-label="Reference Number Input Field" onChange={this.handleInputChange} />
                                <label className="text-danger validation-error" tabIndex="0">{parse(this.state.caseNumberError)}</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <button type="submit" className="btn btn-secondary" aria-label="Submit Button" onClick={this.handleSubmit}>Submit</button>
                                <br />
                                <p className="font-weight-bold font-italic" tabIndex="0">Cuir Faoi Bhráid</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col" tabIndex="0" >
                                To make a payment please enter your Case Reference Number which you<br />
                                will find in the top right hand corner of your notice under “Ref No”.
                                <br />
                                <br />
                                <span className="font-italic">Chun íocaíocht a dhéanamh cuir isteach Uimhir Thagartha do Cháis le do thoil,<br />
                                    gheobhaidh tú í seo sa chúinne uachtarach ar dheis ded' fhógra faoi “Ref No”.</span>
                            </div>
                        </div>
                    </form>
                </div>
            );
        }
    }
}